import { GetMyBusinessesResponse } from "@1games-ru/region-shared/dist/backend/requests/business";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import SelectScreenCard from "@/shared/widgets/SelectScreenCard";
import { SelectScreenCardTypes } from "@/assets/constants/selectScreenCardTypes";

type Props = {
  list: GetMyBusinessesResponse;
  maxCards?: number;
  isGrid?: boolean;
  getCardImage: (imageId: number, type?: string) => string;
  onChangeSelected?: (item) => void;
  isLogo?: boolean;
  Icon: (props: { className?: string }) => JSX.Element;
};

export default function SelectScreenCardsList({
  list,
  maxCards = 3,
  isGrid,
  getCardImage,
  onChangeSelected,
  isLogo,
  Icon,
}: Props) {
  const { t } = useTranslation("business");
  const emptyCardsCount = isGrid && list?.length < 7 ? 6 - list.length : 0;
  const emptyArr = Array.from({ length: emptyCardsCount }, (_, i) => i);

  return isGrid ? (
    <div className="relative grow inset-0">
      <div
        className={clsx(
          "absolute top-0 left-0 bottom-0 grid grid-cols-3 gap-[0.9375rem] overflow-x-clip w-[calc(100%+1.0625rem)] pr-[0.8125rem] overflow-y-auto [--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]",
          isGrid ? "auto-rows-[15rem]" : "auto-rows-min",
        )}
      >
        {list?.length > 0 &&
          list.map((item) => (
            <SelectScreenCard
              key={item.id}
              type={SelectScreenCardTypes.Purchased}
              level={t(`business.level.${item.level}`)}
              idInfo={`${t("business.business")} #${item.id}`}
              address={`${item.address.streetName} ${item.address.index}`}
              onChangeSelected={() => onChangeSelected(item)}
              cardImage={getCardImage(item.id)}
              logoImage={isLogo && getCardImage(item.id, "logo")}
              levelIcon={<div className="size-2 mx-0.5 bg-dark-900 rounded-[0.125rem] rotate-45" />}
              isGrid
            />
          ))}
        {emptyArr.length > 0 &&
          emptyArr.map((item) => (
            <SelectScreenCard
              key={item}
              type={SelectScreenCardTypes.Empty}
              CardIcon={Icon}
              isGrid
            />
          ))}
      </div>
    </div>
  ) : (
    <div className="flex shrink grow gap-[0.9375rem]">
      {list?.length > 0 &&
        list.map((item) => (
          <SelectScreenCard
            key={item.id}
            type={SelectScreenCardTypes.Purchased}
            level={t(`business.level.${item.level}`)}
            idInfo={`${t("business.business")} #${item.id}`}
            address={`${item.address.streetName} ${item.address.index}`}
            onChangeSelected={() => onChangeSelected(item)}
            cardImage={getCardImage(item.id)}
            maxCards={maxCards}
            logoImage={isLogo && getCardImage(item.id, "logo")}
            levelIcon={<div className="size-2 mx-0.5 bg-dark-900 rounded-[0.125rem] rotate-45" />}
          />
        ))}

      {!list?.length && (
        <>
          <SelectScreenCard type={SelectScreenCardTypes.Empty} maxCards={maxCards} />
          <SelectScreenCard type={SelectScreenCardTypes.Empty} maxCards={maxCards} />
        </>
      )}

      {list?.length === 1 && (
        <SelectScreenCard type={SelectScreenCardTypes.Empty} maxCards={maxCards} CardIcon={Icon} />
      )}

      {maxCards > 2 && (
        <SelectScreenCard type={SelectScreenCardTypes.Blocked} maxCards={maxCards} />
      )}
    </div>
  );
}
